import { Provider } from 'react-redux';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from './routes';
import configureStore from './configureStores';
import { createHashHistory } from 'history';
import { TIMING_STRATEGIES, startInteraction } from '@rosetta/eve-client';

import 'moment/locale/de';
import 'moment/locale/es';
import 'moment/locale/fr';
import 'moment/locale/id';
import 'moment/locale/it';
import 'moment/locale/ja';
import 'moment/locale/ko';
import 'moment/locale/nl';
import 'moment/locale/pl';
import 'moment/locale/pt-br';
import 'moment/locale/ru';
import 'moment/locale/vi';
import 'moment/locale/zh-cn';
import 'react-dates/initialize';
import './fonts.css';
import './index.css';

import './modules/app/services/init-data-dog';

startInteraction('application-startup', TIMING_STRATEGIES.FROM_PAGE_START);

const history = createHashHistory();
const store = configureStore(history);

const renderApp = () => {
  return ReactDOM.render(
    <Provider store={store}>
      <Router history={history} />
    </Provider>,
    document.getElementById('root')
  );
};

renderApp();



// WEBPACK FOOTER //
// ./src/index.js